export enum EVENT_SOURCE {
  APP = 'app',
  WEB = 'web',
}
